import { HttpInterceptorFn } from '@angular/common/http';
import { inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { MobileTokenService } from './mobile-token';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
    const platformId = inject(PLATFORM_ID);

    // SE ESTIVER NO SERVIDOR (SSR), NÃO ENVIA REQUISIÇÃO DE REDE DA WEBVIEW
    if (!isPlatformBrowser(platformId)) {
        return next(req);
    }

    const mobileTokenService = inject(MobileTokenService);

    // 1. Tenta obter o token pelo seu serviço padrão de mobile
    let token = mobileTokenService.getToken();

    // 2. FALLBACK WEBVIEW GARANTIDO: Coleta direto das variáveis globais injetadas pelo Flutter
    if (!token) {
        token = (globalThis.window as any).flutter_token_value ||
            (globalThis.window as any).mobileToken ||
            sessionStorage.getItem('flutter_token') ||
            sessionStorage.getItem('auth_token');
    }

    // 3. Se encontrou o token, anexa obrigatoriamente no cabeçalho Bearer
    if (token) {
        const clonedRequest = req.clone({
            setHeaders: {
                Authorization: `Bearer ${token}`
            }
        });
        return next(clonedRequest);
    }

    return next(req);
};
